<template>
  <v-container
    fill-height
    fluid
    grid-list-xl>
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        xs12
        md8
      >
        <v-card
          color="white"
          title="Edit Profile"
          text="Complete your profile"
        >
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    label="Level (disabled)"
                    disabled/>
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    class="purple-input"
                    label="User Name"
                  />
                </v-flex>
                <v-flex
                  xs12
                  md4
                >
                  <v-text-field
                    label="Email Address"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    label="First Name"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md6
                >
                  <v-text-field
                    label="Last Name"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md12
                >
                  <v-text-field
                    label="Adress"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md4>
                  <v-text-field
                    label="City"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md4>
                  <v-text-field
                    label="Country"
                    class="purple-input"/>
                </v-flex>
                <v-flex
                  xs12
                  md4>
                  <v-text-field
                    class="purple-input"
                    label="Postal Code"
                    type="number"/>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    class="purple-input"
                    label="About Me"
                    value="Playing game for better life."
                  />
                </v-flex>
                <v-flex
                  xs12
                  text-xs-right
                >
                  <v-btn
                    class="mx-0 font-weight-light"
                    color="success"
                  >
                    Update Profile
                  </v-btn>
                  
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card>
      </v-flex>
      <v-flex
        xs12
        md4
      >
   
<v-container class="topcontainer">
<div class="image-list">
<div style="text-align:center" ref="divGenres" class="list-default-img" v-show="isPhoto" @click.stop="addPic">
  <v-avatar :size="120">
  <img src="https://randomuser.me/api/portraits/men/85.jpg">
  </v-avatar>
<br>
<h5>Click Change Your Avatar</h5>
<input type="file" accept="image/jpg,image/png,image/jpeg,image/gif" capture="camera" @change="onFileChange" style="display: none;">
</div>
<ul class="list-ul" v-show="!isPhoto">
<md-avatar class="list" v-for="(iu, index) in imgUrls" :key="index">
<img :src="iu">
<span class="list-img-close" @click='delImage(index)'></span>
</md-avatar>
</ul>
</div>

    
      
          <v-card-text class="text-xs-center">
            <h6 class="category text-gray font-weight-thin mb-3">Noob</h6>
            <h4 class="card-title font-weight-light">Bo Wang</h4>
            <p class="card-description font-weight-light">Everthing is funny</p>
            <v-btn
              color="success"
              round
              class="font-weight-light"
            >Follow</v-btn>
          </v-card-text>
</v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import lrz from 'lrz'

export default {
    data () {
      return {
      show: false,
imgUrls: [],
urlArr: [],
isPhoto: true,
btnTitle: '',
isModify: false,
    }
},
watch: {
imgUrls: 'toggleAddPic'
},
methods: {
toggleAddPic: function () {
let vm = this;
if (vm.imgUrls.length >= 1) {
vm.isPhoto = false;
} else {
vm.isPhoto = true;
}
},
addPic: function (e) {
let els = this.$refs.divGenres.querySelectorAll('input[type=file]')
els[0].click()
return false
},
onFileChange: function (e) {
var files = e.target.files || e.dataTransfer.files;
if (!files.length) return;
this.createImage(files, e);
},
createImage: function (file, e) {
let vm = this;
lrz(file[0], {width: 330}, {height: 110
}).then(function (rst) {
vm.imgUrls.push(rst.base64);
return rst;
}).always(function () {
// 清空文件上传控件的值
e.target.value = null;
});
},
delImage: function (index) {
let vm = this;
vm.$vux.confirm.show({
title: '确定删除该图片?',
onConfirm() {
vm.imgUrls.splice(index, 1);
}
})

},
previewImage: function (url) {
let vm = this;
vm.isPreview = true;
vm.previewImg = url;
},
closePreview: function () {
let vm = this;
vm.isPreview = false;
vm.previewImg = "";
},
saveImage: function () {
let vm = this;
let urlArr = [],
imgUrls = this.imgUrls;

for (let i = 0; i < imgUrls.length; i++) {
if (imgUrls[i].indexOf('file') == -1) {
urlArr.push(imgUrls[i].split(',')[1]);
} else {
urlArr.push(imgUrls[i]);
}
}

//数据传输操作
}
}
}
</script>

<style scoped>
.list{
width: 100px;
height: 100px;
left:30%;
margin-bottom: 5px;
margin-top: 8px;
}
.topcontainer{
  margin-top: 15px;
}
</style>


